export default "__VITE_ASSET__pcH6RxDw__"